import {config} from "../../constants/config";

export default {
  ACCESS_TOKEN: localStorage.getItem('ACCESS_TOKEN'),
  currentUser: null,
}



// WEBPACK FOOTER //
// ./src/store/moduleUser/state.js